module.exports = __webpack_public_path__ + "images/share_icon_facebook.ea812bb2.png";